module.exports = __webpack_public_path__ + "media/images/icon-hint-a56dba6497b759ac2917ef35b646cab7.svg";